import React from "react";
import RoleProgress from "../../progressBar/RoleProgress";
import { Link } from "react-router-dom";
import { createRole } from "../../../sdk/users/modules";

const FinishPermissions = ({
  id,
  closeReviewPermissionsModal,
  reviewPermissionsModalOpen,
  openPermissionsModal,
  roleName,
  roleDescription,
  openModal,
  selectedPermissions,
  modules,
  fetchRoles,
  setAddRoleSuccessOpen,
}) => {
  const handleCreateRole = async () => {
    const response = await createRole(
      roleName,
      roleDescription,
      selectedPermissions
    );
    if (response.statusCode === 201) {
      closeReviewPermissionsModal();
      fetchRoles();
      setAddRoleSuccessOpen(true);
      setTimeout(() => {
        setAddRoleSuccessOpen(false);
      }, 2000);
    }
  };

  const handleBackButtonClick = () => {
    closeReviewPermissionsModal();
    openPermissionsModal();
  };

  const handleEditButton = () => {
    closeReviewPermissionsModal();
    openModal();
  };

  return (
    <div
      id={id}
      className={`${
        reviewPermissionsModalOpen ? "flex" : "hidden"
      } items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
    >
      <div className="relative flex fixed min-h-[80%] w-[65%]">
        <div className="relative flex-col flex bg-white shadow w-full mx-auto">
          <div
            onClick={closeReviewPermissionsModal}
            className="flex items-center justify-end p-2 cursor-pointer"
          >
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.74039 11.1602L5.60039 8.06016L3.80039 11.1602H0.100391L3.78039 5.46016L0.000390632 0.000155687H3.84039L5.98039 3.08016L7.78039 0.000155687H11.4804L7.74039 5.62016L11.5804 11.1602H7.74039Z"
                fill="black"
              />
            </svg>
          </div>
          <div className="flex">
            <div className=" w-[28%]">
              <div className="py-2 rounded-t">
                <p className="text-[20px] font-bold text-[#000] ml-5">
                  Create a new role
                </p>
              </div>
              <div className="mt-6 px-6">
                <RoleProgress step={4} />
              </div>
            </div>
            <div className="w-[72%] flex flex-col mt-5 justify-between">
              <div>
                <div className="mt-3 mx-auto items-center">
                  <p className="text-[#000] text-xl font-bold">
                    Review and finish
                  </p>
                  <div className="text-[#000] w-[90%] mt-2 text-sm font-normal">
                    <p>
                      Great work! You've provided all the necessary details for
                      the new user. Take a moment to review and confirm the
                      settings below:
                    </p>
                  </div>
                </div>
                <div className="flex justify-between w-[70%] mt-6">
                  <div className="w-[50%]">
                    <p className="text-[#000000] text-[16px] font-[500]">
                      Role Name
                    </p>
                    <p className="text-[#4F4F4F]">{roleName}</p>
                    <p
                      onClick={handleEditButton}
                      className="text-[#06B217] text-[14px] font-[400] cursor-pointer"
                    >
                      Edit
                    </p>
                  </div>
                  <div className="w-[50%]">
                    <p className="text-[#000000] text-[16px] font-[500]">
                      Role description
                    </p>
                    <p className="text-[#4F4F4F]">{roleDescription}</p>
                    <p
                      onClick={handleEditButton}
                      className="text-[#06B217] text-[14px] font-[400] cursor-pointer"
                    >
                      Edit
                    </p>
                  </div>
                </div>
                <div className="flex flex-col gap-2 justify-between mt-5 mr-4">
                  <p>Permissions({selectedPermissions?.length})</p>
                  <div className="h-[40vh] w-[90%] border-[1px] border-[#000000] p-3 overflow-y-auto">
                    {modules &&
                      modules?.map((module) => {
                        // Filter only selected permissions in this module
                        const selectedPerms = module?.permissions?.filter(
                          (perm) => selectedPermissions?.includes(perm?.id)
                        );

                        // Do not show module if it has no selected permissions
                        if (selectedPerms?.length === 0) return null;

                        return (
                          <div key={module?.id} className="mb-4">
                            {/* Module name */}
                            <p className="text-[#000] font-bold">
                              {module?.name}
                            </p>

                            {/* Only selected permissions */}
                            {selectedPerms?.map((permission) => (
                              <div
                                key={permission.id}
                                className="flex items-center mt-3"
                              >
                                <div className="w-[65%] mb-3">
                                  <p className="pl-5">{permission?.name}</p>
                                </div>
                                <div className="w-[35%] flex items-center justify-center mb-3">
                                  <input
                                    type="checkbox"
                                    className="custom-checkbox"
                                    readOnly
                                    checked={true}
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        );
                      })}
                  </div>
                </div>
                <div className="mt-[10px]">
                  <p
                    onClick={handleBackButtonClick}
                    className="text-[#06B217] text-[14px] font-[400] cursor-pointer"
                  >
                    Edit
                  </p>
                </div>
              </div>
              <div className="flex w-[90%] items-center justify-between mt-5 mb-5 pr-[15px]">
                <div className="flex items-center gap-[20px] w-[15vw]">
                  <button
                    onClick={handleBackButtonClick}
                    data-modal-toggle={id}
                    type="button"
                    className="text-[#000] bg-[#8ED6A8] hover:bg-[#8ED6A8] focus:outline-none font-medium rounded-[5px] text-sm px-8 py-2.5 text-center"
                  >
                    Back
                  </button>
                  <button
                    onClick={handleCreateRole}
                    data-modal-toggle={id}
                    type="button"
                    className="text-white bg-[#005C53] hover:bg-[#005C53] focus:outline-none font-medium rounded-[5px] text-sm px-8 py-2.5 text-center"
                  >
                    Finish
                  </button>
                </div>
                <button
                  onClick={closeReviewPermissionsModal}
                  data-modal-toggle={id}
                  type="button"
                  className="text-gray-500 bg-[#D9D9D9] hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-[5px] border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinishPermissions;
